import { MODES_DE_LA_CARTE } from './listes.js';
/*
 * Le mode d'une feuille (chantier modes-de-la-carte, deuxième passe de 01 et 02, retour d'Igor du
 * 2026-10-21 : « le mode doit etre reglable a tout les niveau du projet ») : le préréglage des
 * touches de sa Carte et de sa Hiérarchie. Toute bulle peut avoir le sien ; `null` en base vaut
 * « comme la mère ».
 */
/** Une feuille où personne n'a choisi : De base. */
export const MODE_PAR_DEFAUT = 'de-base';
/** Le mode d'une bulle tel que la base le garde : une valeur hors de la liste vaut `null`, rien de choisi. */
export function modeChoisi(valeur) {
    return MODES_DE_LA_CARTE.includes(valeur ?? '') ? valeur : null;
}
/**
 * **Le mode d'une feuille**, la règle écrite une fois : celui de la bulle ouverte, sinon celui de
 * la mère la plus proche qui en a un (le projet compris), sinon De base. Le serveur l'appelle (la
 * feuille rend le mode à appliquer) ; l'écran aussi, quand un mode vient d'être choisi.
 *
 * `lire` rend une bulle par son identifiant ; `auDessus`, le mode qui vient des mères qu'on ne lit
 * pas (l'écran ne connaît que la feuille : il passe le mode hérité qu'elle porte). Un mode hors de
 * la liste ne compte pas ; une boucle sur les mères s'arrête.
 */
export function modeDeLaFeuille(id, lire, auDessus = null) {
    const vues = new Set();
    let bulle = lire(id);
    while (bulle && !vues.has(bulle.id)) {
        vues.add(bulle.id);
        const sien = modeChoisi(bulle.mode);
        if (sien)
            return sien;
        if (bulle.parentId === null)
            return MODE_PAR_DEFAUT;
        const mere = lire(bulle.parentId);
        if (!mere)
            return auDessus ?? MODE_PAR_DEFAUT;
        bulle = mere;
    }
    return MODE_PAR_DEFAUT;
}
